__webpack_require__.p = "https://umpdevops.gro247.com/mywizardplatform/";